import { render } from "./gallery.vue?vue&type=template&id=4679991b"
import script from "./gallery.js?vue&type=script&lang=js"
export * from "./gallery.js?vue&type=script&lang=js"

import "./gallery.vue?vue&type=style&index=0&id=4679991b&lang=scss"

import exportComponent from "/woodpecker/src/akkoma.dev/AkkomaGang/akkoma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__